(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["wm-footer"] && !Shopify.designMode) return;
  try {
    
  /* JS lives in assets/wm-footer.js */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wm-header"] && !Shopify.designMode) return;
  try {
    
  /* JS lives in assets/wm-header.js — do not write scripts here */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wm-hero"] && !Shopify.designMode) return;
  try {
    
  /* JS lives in assets/wm-hero.js — do not write scripts here */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wm-industries"] && !Shopify.designMode) return;
  try {
    
  /* JS lives in block files — no section-level JS required */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wm-product-feature"] && !Shopify.designMode) return;
  try {
    
  /* No JS required — sticky behaviour is handled via CSS */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wm-section"] && !Shopify.designMode) return;
  try {
    
  /* No JS for this section */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wm-technology"] && !Shopify.designMode) return;
  try {
    
  /* No JS required for this section */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wm-value-props"] && !Shopify.designMode) return;
  try {
    
  /* JS lives in assets/wm-value-props.js — do not write scripts here */

  } catch(e) { console.error(e); }
})();
})();
